import { Navigate, Outlet, useLocation } from 'react-router-dom'

export function RequireAuth() {
  const location = useLocation()
  const jwt = localStorage.getItem('discover.jwt')
  if (!jwt) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/auth/signin?next=${next}`} replace />
  }
  return <Outlet />
}
